import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ApiAutenticacaoService } from '../../services/api-autenticacao.service';
import { ehErroAcessoObjetivoBloqueado } from '../models/acesso-objetivo-bloqueado.error';

export const usuarioLogadoGuard: CanActivateFn = () => {

  const apiAuth = inject(ApiAutenticacaoService);
  const router = inject(Router);

  const urlLogin = router.parseUrl('/');

  // Considera cookie/token OU cache em sessionStorage: uma sessão de instituto bloqueado pode
  // não ter cookie de token (addSession nunca persiste cookie para institutos Objetivo/Curso),
  // mas ainda precisa passar por sessaoValida() para ser classificada e redirecionar para
  // /acesso-objetivo em vez de simplesmente cair no login.
  if (!apiAuth.possuiIndicioDeSessao()) {
    apiAuth.logout();
    return urlLogin;
  }

  return apiAuth.sessaoValida().pipe(
    map(sessao => {
      if (sessao.valida === true) { return true; }
      apiAuth.logout();
      return urlLogin;
    }),
    catchError(erro => {
      // Instituto bloqueado: o AcessoObjetivoService já navegou para /acesso-objetivo
      // (replaceUrl). Apenas cancela esta navegação - nunca redireciona para o login,
      // e evita que outros guards concorrentes disparem uma segunda navegação.
      if (ehErroAcessoObjetivoBloqueado(erro)) { return of(false); }
      apiAuth.logout();
      return of(urlLogin);
    })
  );
};
